import { Children } from 'react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import type { Property } from 'csstype';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: left;
	align-content: stretch;
`;

interface ItemProps<T = string | number> {
	width: Property.Width<T>;
	height: Property.Height<T>;
}

const Item = styled.div<ItemProps>`
	position: relative;
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	margin: 1vmin;
`;

interface Props extends PositionAndSizeProps {
	columns: number;
	rows: number;
	className?: string;
}

const Grid: FunctionComponent<Props> = (props: PropsWithChildren<Props>) => {
	const { className, columns, rows, children } = props;

	const items = Children.map(children, (child) => (
		<Item
			width={`calc(100% / ${columns} - ${columns}vmin)`}
			height={`calc(100% / ${rows} - ${rows}vmin)`}
		>
			{child}
		</Item>
	));

	return <Container className={className}>{items}</Container>;
};

export default styled(Grid)<PositionAndSizeProps>(PositionAndSizeFromProps);
